<template>
    <v-dialog
      v-model="openMembersChannelDialog"
      persistent
      max-width="420"
      class="manage-members mx-auto overflow-hidden"
    >
    <v-card
      class="d-flex flex-row mx-auto overflow-hidden"
      flat
      width="420"
      tile
    >
      <v-card v-if="channel">
        <v-card-title class="text-h5">
          <span class="manage-members-title"> {{ $t('chat.members.title') }} <b :class="getTextColor">{{channel.formatName()}}</b></span>
        </v-card-title>

        <v-btn
          v-if="channel.isOwner()"
          class="ma-4"
          cols="1"
          fab
          small
        >
          <v-icon
            v-on:click="availableUsersDrawer()"
            color="primary"
          >
            mdi-plus
          </v-icon>
        </v-btn>

        <v-list dense>
          <v-list-item-group v-model="memberSelected">
            <v-list-item
              v-for="(member) in channelMembers"
              :key="member.username"
              style="display: -webkit-box !important;"
            >
                <v-list-item-action>
                  <StatusAvatar :user="getUser(member.username)"/>
                </v-list-item-action>

                <v-list-item-content style="margin: 0px !important;min-width: 145px !important;">
                  <v-list-item-title v-html="member.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="member.username"></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action style="margin: 0px !important;">
                </v-list-item-action>

                <v-list-item-action style="margin: 0px !important;">
                  <v-list-item-action-text v-text="$t('chat.members')[member.rolesFlatten()]"></v-list-item-action-text>
                  <v-menu v-if="channel.isOwner()">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                      >
                          <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item
                          v-for="(contextMenu, index) in member.contextMenus()"
                          :key="index"
                          style="display: -webkit-box !important;"
                          :disabled="member.displayAction(currentUser, contextMenu.key)"
                          @click="navChannelContextMenu(contextMenu, member)"
                      >
                          <v-list-item-icon>
                          <v-icon :color="contextMenu.color">{{contextMenu.icon}}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>{{ $t('chat.contextMenu')[contextMenu.key] }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeDialog()"
          >
            {{ $t('chat.members.btn.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <AvailableUsersDrawer/>

    </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AvailableUsersDrawer from './members/available_users_drawer'
import StatusAvatar from '@/components/buddies/status_avatar'

export default {
  name: 'chat-membersChannelDialog',
  data () {
    return {
      memberSelected: null
    }
  },
  created () {
    this.getChannelMembers(this.channel.id)
  },
  computed: {
    ...mapGetters({
      openMembersChannelDialog: 'chat/openMembersChannelDialog',
      channel: 'chat/contextMenuChannel',
      channelMembers: 'chat/channelMembers',
      chatUsers: 'chat/users',
      users: 'users/listAll',
      currentUser: 'chat/authenticatedRocketChatUser'
    }),
    getColor: function () {
      return this.channel?.conversationColorScheme()
    },
    getTextColor: function () {
      return `${this.getColor}--text`
    }
  },
  components: {
    AvailableUsersDrawer,
    StatusAvatar
  },
  methods: {
    ...mapActions({
      closeDialog: 'chat/openMembersChannelDialog',
      openChannelActionDialog: 'chat/openChannelActionDialog',
      getChannelMembers: 'chat/getChannelMembers',
      availableUsersDrawer: 'chat/availableUsersDrawer',
      setContextMenuMember: 'chat/setContextMenuMember'
    }),

    getChatUser (username) {
      return this.chatUsers.find((chat) => chat.chat_username === username)
    },

    getUser (username) {
      return this.users.find((user) => user.exten === this.getChatUser(username)?.exten)
    },

    navChannelContextMenu (contextMenu, member) {
      const channelAction = contextMenu.key
      const channel = this.channel
      const options = { channelAction: channelAction, channel: channel }
      this.setContextMenuMember(member)
      this.openChannelActionDialog({ options })
    }

  }
}
</script>

<style scoped>
</style>
